import React from "react";
import { saveAs } from "file-saver";
import { Button } from "@material-tailwind/react";

const XLSX = require("xlsx");

const ExcelExport = ({ data, fileName, btnText, onClickFn }) => {
  const exportToExcel = () => {
    const imageColumnHeader = "Profile Image";
    const imageHeight = 100;
    const imageWidth = 100;
    const processedData = data?.map((row) => {
      const newRow = { ...row };
      if (
        newRow[imageColumnHeader] &&
        typeof newRow[imageColumnHeader] === "string"
      ) {
        const url = newRow[imageColumnHeader];
        newRow[
          imageColumnHeader
        ] = `=IMAGE("${url}", 4, ${imageHeight}, ${imageWidth})`;
      }
      return newRow;
    });

    if (!processedData || processedData.length === 0) {
      return alert("No data to export.");
    }

    const worksheet = XLSX.utils.json_to_sheet(processedData);
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    const headers = Object.keys(processedData[0]);
    const imageColIndex = headers.indexOf(imageColumnHeader);
    if (imageColIndex >= 0) {
      const imageColLetter = XLSX.utils.encode_col(imageColIndex);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const cellAddress = `${imageColLetter}${row + 1}`;
        const cell = worksheet[cellAddress];

        if (
          cell &&
          typeof cell.v === "string" &&
          cell.v.startsWith('=IMAGE("')
        ) {
          cell.t = "f";
          cell.f = cell.v.slice(1);
          delete cell.v;
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <Button
      onClick={() => {
        exportToExcel();
        onClickFn();
      }}
      className="rounded-md font-ibm-semibold text-white bg-[#EF4444] hover:bg-opacity-80 px-5 py-3 text-sm shadow-none hover:shadow-none normal-case transition-all duration-300 ease-in-out flex-shrink-0"
      type="button"
    >
      {btnText}
    </Button>
  );
};

export default ExcelExport;
